const zIndex = {
    tooltip: 1600,
}

export default zIndex